<template>
  <div>
    <div v-if="order">
      <vx-card :title="`Order`" class="mb-5">
        <vs-row class="mb-1" v-if="order.userId">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">User Id</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.userId }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Full Name</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.billingAddress.firstName }} {{ order.billingAddress.lastName }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2"  style="font-weight: bold;">Email</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.email }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Order Id</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.orderId }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Order Number</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.orderNumber }}</vs-col>
        </vs-row>
        <vs-row class="mb-1" v-if="macAddress">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Scanner Mac Address</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ macAddress }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Status</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10" v-if="order.fulfillmentType === 'auto'">{{ order.status.split('_').join(" ") }}</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10" v-else>
            <vs-select
              label=""
              v-model="order.status"
              class="mr-4 vs-input-shadow-drop vs-select-no-border vx-col">
              <vs-select-item
                v-for="(val, index) in orderStatuses"
                :key="`order-count-${index}`"
                :value="val.value"
                :text="val.text"
              />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Fulfillment Type</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.fulfillmentType }}</vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Order Date</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ moment(order.orderDate).format('MM-DD-YYYY hh:mm A') }}</vs-col>
        </vs-row>
        <vs-row class="mb-3" v-if="order.fulfillmentType !== 'manual'">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Process Date</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ moment(order.shipTime).format('MM-DD-YYYY hh:mm A') }}</vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-xs="6" vs-sm="4" vs-lg="2" style="font-weight: bold;">Order Source</vs-col>
          <vs-col vs-xs="6" vs-sm="8" vs-lg="10">{{ order.source.split('_').join(' ') }}</vs-col>
        </vs-row>
        <vs-row class="mt-3">
          <vs-col>
            <vs-button
              v-if="order.fulfillmentType === 'manual'"
              color="primary"
              class="mr-2"
              @click="exportOrderCsv"
            >
              Export Csv
            </vs-button>
            <vs-button
              v-if="order.fulfillmentType === 'auto' && order.status === 'pending' || order.fulfillmentType === 'manual' && order.status === 'pending' && !order.shipments"
              color="primary"
              class="mr-2"
              @click="showOrderFulfillmentTypeDialog = true"
            >
              Fulfill {{ order.fulfillmentType === 'auto' ? 'Manually' : 'Automatically' }}
            </vs-button>
            <vs-button
              v-if="order.fulfillmentType === 'auto' && order.status === 'pending'"
              color="primary"
              @click="showUpdateShipTimeDialog = true"
            >
              Process Now
            </vs-button>
          </vs-col>
        </vs-row>
      </vx-card>

      <vs-row class="mb-5">
        <vs-col vs-sm="12" vs-lg="6" class="order-billing-address">
          <vx-card title="Billing Address">
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Address 1</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.address1 }}</vs-col>
              </vs-row>
              <vs-row v-if="order.billingAddress.address2.split('').length">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Address 2</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.address2 }}</vs-col>
              </vs-row>
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">City</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.city }}</vs-col>
              </vs-row>
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">State/Province</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.provinceCode }}</vs-col>
              </vs-row>
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Zip</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.zip }}</vs-col>
              </vs-row>
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Country</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.countryCode }}</vs-col>
              </vs-row>
              <vs-row class="mb-1">
                <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Phone</vs-col>
                <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.billingAddress.phone }}</vs-col>
              </vs-row>
          </vx-card>
        </vs-col>
        <vs-col vs-sm="12" vs-lg="6" class="order-shipping-address">
          <vx-card title="Shipping Address">
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Address 1</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.address1 }}</vs-col>
            </vs-row>
            <vs-row v-if="order.shippingAddress.address2.split('').length">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Address 2</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.address2 }}</vs-col>
            </vs-row>
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">City</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.city }}</vs-col>
            </vs-row>
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">State/Province</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.provinceCode || order.shippingAddress.province}}</vs-col>
            </vs-row>
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Zip</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.zip }}</vs-col>
            </vs-row>
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Country</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.countryCode || order.shippingAddress.country }}</vs-col>
            </vs-row>
            <vs-row class="mb-1">
              <vs-col vs-xs="6" vs-lg="5" vs-sm="4" style="font-weight: bold;">Phone</vs-col>
              <vs-col vs-xs="6" vs-lg="7" vs-sm="8">{{ order.shippingAddress.phone }}</vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
      </vs-row>
      <vx-card title="Line Items" class="mb-5">
        <vs-button @click="showCreateOrderShipmentDialog = true" class="mb-2" v-if="order.fulfillmentType === 'manual' && order.status === 'pending' && !order.shipments" color="primary">Create Shipments</vs-button>
        <line-item-table :line-items="order.lineItems" :headers="headers" />
      </vx-card>
      <vx-card title="Shipping Information" v-if="order.shipments">
        <template v-for="(shipment, index) in order.shipments">
          <vx-card class="mb-4" :key="`shipment-${index}`">
            <h4 class="mb-2">{{shipment.location.name}} - {{shipment.location.service}}</h4>
            <h6 class="mb-2">Shipment Status: {{shipment.status.split('_').join(' ')}}</h6>
            <vs-button v-if="order.fulfillmentType === 'manual'" @click="showCreateShippingLabelDialog(shipment.location._id)" class="mt-2 mb-2" color="primary" size="small">Add Tracking Number</vs-button>
            <shipping-label-table class="mt-4" v-if="shipment.shippingLabels.length" :shipping-labels="shipment.shippingLabels"/>
            <line-item-table :line-items="shipment.lineItems" :headers="headers"/>
          </vx-card>
        </template>
      </vx-card>
      <order-fulfillment-type-dialog :showOrderFulfillmentTypeDialog.sync="showOrderFulfillmentTypeDialog" :order.sync="order" :refresh="fetch" />
      <create-order-shipment-dialog v-if="order && order.fulfillmentType === 'manual'" :showCreateOrderShipmentDialog.sync="showCreateOrderShipmentDialog" :order.sync="order" :refresh="fetch" />
      <create-order-shipment-label-dialog v-if="createOrderShipmentLabelDialog.show" :create-order-shipment-label-dialog.sync="createOrderShipmentLabelDialog" :refresh="fetch" />
      <update-ship-time-dialog :show-update-ship-time-dialog.sync="showUpdateShipTimeDialog" :order.sync="order" :refresh="fetch" />
    </div>
    <div v-else>No order found</div>
  </div>
</template>

<style lang="css" scoped>
  @media only screen and (min-width: 901px){
    .order-shipping-address { padding-left: 8px; }
    .order-billing-address{ padding-right: 8px; }
  }
  @media only screen and (max-width: 900px){
    .order-billing-address{ margin-bottom: 20px; }
  }
</style>

<script>
  import api from '@/http/api';
  import moment from 'moment';
  import LineItemTable from './components/LineItemTable';
  import ShippingLabelTable from "@/views/orders/components/ShippingLabelTable";
  import OrderFulfillmentTypeDialog from "@/views/orders/components/OrderFulfillmentTypeDialog";
  import CreateOrderShipmentDialog from "@/views/orders/components/CreateOrderShipmentDialog";
  import CreateOrderShipmentLabelDialog from "@/views/orders/components/CreateOrderShipmentLabelDialog";
  import UpdateShipTimeDialog from "@/views/orders/components/UpdateShipTimeDialog";
  import { ExportToCsv } from 'export-to-csv';

  export default {
    components: {
      LineItemTable,
      OrderFulfillmentTypeDialog,
      CreateOrderShipmentDialog,
      ShippingLabelTable,
      CreateOrderShipmentLabelDialog,
      UpdateShipTimeDialog
    },
    data() {
      return {
        order: null,
        headers: ['Sku', 'Name', 'Price', 'Tax', 'Discount', 'Qty', 'Requires Shipping'],
        orderStatuses: [
          { text: "Pending", value: 'pending' },
          { text: "Awaiting Shipment", value: 'awaiting_shipment' },
          { text: "Shipped", value: 'shipped' },
          { text: "Partially Shipped", value: 'partially_shipped' },
          { text: "Cancelled", value: 'cancelled' },
        ],
        showOrderFulfillmentTypeDialog: false,
        showCreateOrderShipmentDialog: false,
        createOrderShipmentLabelDialog: {
          show: false,
          orderId: null,
          shipmentLocationId: null
        },
        showUpdateShipTimeDialog: false,
        macAddress: null
      }
    },
    mounted() {
      this.fetch();
    },
    watch: {
      'order.status': async function (newVal, oldVal) {
        if (!newVal || newVal === oldVal) return;
        await this.updateOrder({status: newVal});
      }
    },
    methods: {
      moment:moment,
      async fetch() {
        this.$vs.loading();

        const orderId = this.$route.params.id;
        this.order = await api.getOrderById(orderId);

        if (this.order && this.order.shipments) {
          const shipment = this.order.shipments.filter(shipment => shipment.macAddress !== null)[0];
          this.macAddress = shipment ? shipment.macAddress : null;
        }

        this.$vs.loading.close();
      },
      exportOrderCsv() {
        const fileName = moment().format("MMMM Do YYYY") + ` Order-${this.order.orderNumber}`;
        const csvHeaders = ['Order Number', 'Name', 'Address 1', 'Address 2', 'City', 'State', 'Postal Code', 'Country', 'Ship Method', 'Date', 'Email', 'Custom SKU', 'Item Quantity', 'Value'];

        const csvExporter = new ExportToCsv({
          filename: fileName,
          showLabels: true,
          showTitle: true,
          title: fileName,
          useKeysAsHeaders: false,
          headers: csvHeaders
        });
        const csvData = this.formatOrderForCsv(this.order)
        csvExporter.generateCsv(csvData);
      },
      formatOrderForCsv(order) {
        return order.lineItems.map(lineItem => {
          return {
            orderNumber: order.orderNumber,
            name: `${order.shippingAddress.firstName} ${order.shippingAddress.lastName}`,
            address1: order.shippingAddress.address1,
            address2: order.shippingAddress.address2,
            city: order.shippingAddress.city,
            state: order.shippingAddress.provinceCode,
            postalCode: order.shippingAddress.zip,
            country: order.shippingAddress.countryCode,
            shipMethod: order.shippingLine.code,
            date: moment(order.orderDate).format('MM/DD/YYYY'),
            email: order.email,
            customSku: lineItem.sku,
            itemQuantity: lineItem.fulfillableQuantity,
            value: Number(lineItem.price) - Number(lineItem.discount)
          }
        })
      },
      async updateOrder( data) {
        this.$vs.loading();
        await api.updateOrder(this.order._id, data);
        this.$vs.loading.close();

        await this.fetch();
      },
      showCreateShippingLabelDialog(shipmentLocationId) {
        this.createOrderShipmentLabelDialog = {
          show: true,
          orderId: this.order._id,
          shipmentLocationId: shipmentLocationId
        }
      }
    }
  }
</script>
